import api from "src/api/axios";

const getLogs = async ({ limit, page }) => {
  const params = new URLSearchParams({
    page: page ? page : "1",
    limit: limit ? limit : "10",
  });
  return api.get(`/logs?${params}`).then((result) => {
    return result.data;
  });
};

export { getLogs };
